import { z } from 'zod';
import { UPLOAD_PROFILE_CONSTRAINTS } from '@/lib/constants/account';

export const uploadProfileSchema = z.object({
  label: z.string()
    .trim()
    .min(1, 'Label is required')
    .max(
      UPLOAD_PROFILE_CONSTRAINTS.LABEL_MAX,
      `Cannot exceed ${UPLOAD_PROFILE_CONSTRAINTS.LABEL_MAX} characters`,
    ),
  transcodeVodId: z.number().nullable(),
  tags: z.array(z.string().min(1, 'Tag cannot be empty')),
  allowAddTags: z.boolean(),
  allowEditDefaultTags: z.boolean(),
  allowPublish: z.boolean(),
});

export type UploadProfileFormValues = z.infer<typeof uploadProfileSchema>;

export const UPLOAD_PROFILE_DEFAULTS: UploadProfileFormValues = {
  label: '',
  transcodeVodId: null,
  tags: [],
  allowAddTags: true,
  allowEditDefaultTags: true,
  allowPublish: true,
};
